var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1928_481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4006 18.8184L28.8049 25.3108C29.7573 26.2727 29.7573 27.8309 28.8049 28.7927C27.8574 29.7546 26.3171 29.7546 25.3695 28.7927L19.0527 22.382",
    stroke: "#1F57A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1695 12.4944C24.1695 19.1264 18.8683 24.5079 12.3279 24.5079C5.78759 24.5079 0.486328 19.1264 0.486328 12.4944C0.486328 5.86249 5.78759 0.480957 12.3279 0.480957C18.8683 0.480957 24.1695 5.85768 24.1695 12.4944Z",
    stroke: "#1F57A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.18359 12.5087C3.18359 11.2246 3.44113 10.0031 3.90274 8.89213C4.36435 7.7812 5.03491 6.78088 5.86581 5.93927C6.69671 5.09765 7.68311 4.41955 8.7764 3.94824",
    stroke: "#1F57A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42773 15.8706V18.2896",
    stroke: "#1F57A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37695 13.7402V18.2898",
    stroke: "#1F57A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3262 10.1284V18.2897",
    stroke: "#1F57A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2754 11.3882V18.2894",
    stroke: "#1F57A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2266 7.34375V18.2896",
    stroke: "#1F57A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1928_481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeo);
export default __webpack_public_path__ + "static/media/seo.095cd0027d781f08b14cdc60a290ca9c.svg";
export { ForwardRef as ReactComponent };